import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormRegion } from './types';

export const transformDataset = (values: FiltersFormRegion): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: { value: otherValues.code },
    nome: { value: otherValues.name },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    nome: ordersToTransform.name,
  };

  return `?${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
